<template>
  <a-card :bordered="false"  :spinning="isUploaddingData"  >
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <div  class="operate-div" >
          <div  class="base-div"  >
            <a-form-item label="基地"  class="margin-botton-0"  >
                <j-dict-select-tag placeholder="请选择部门"   :isChooseFirst="true"  @chooseFirst="handleGotoToday" v-model="baseValue"  @input="handleChangeBase"   dictCode="bus_inspection_general_base,base,id,status = '1'" />
            </a-form-item>
          </div>
          <div  class="year-div"  >
            <a-form-item label="时间" class="margin-botton-0"  >
              <a-select  :value="nowYear"   @change="handleChangeYear"  >
                <a-select-option  v-for="item in yearOption"  :value="item"  :key="item"  >{{item}}年</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <a-icon type="left" class="left-icon" title="上个月" @click="handleLastMonth" />
          <div  class="month-div"  >
            <a-form-item label=""  class="margin-botton-0"  >
              <a-select  :value="nowMonth"  @change="handleChangeMonth"  >
                <a-select-option  v-for="item in momthOption"  :value="item"  :key="item"     >{{item}}月</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <a-icon type="right" title="下个月" @click="handleNextMonth" class="right-icon" />
          <a-button type="primary"  icon="reload"  class="margin-left-20"  @click="handleGotoToday" >返回今天</a-button>
          <a-button type="primary"  icon="form"  class="margin-left-20"  @click="handleEdit" >{{isEditing?'取消编辑':'编辑'}}</a-button>
        </div>
      </a-form>
    </div>
    <div  class="calendar"   >
      <div class="calendar-box"  :class="{'calendar-box-edit':isEditing}"  >
        <div  class="calendar-header"  >
          <p  class="now-date"  >当前时间：{{nowYear}}年{{nowMonth}}月<span v-show="!isEditing" >{{nowDate}}日</span></p>
          <div class="spin-div" v-show="isLoaddingCalendarData"  ><a-spin /><span   class="spin-p"  >加载工厂日历中...</span></div>
        </div>
        <table class="calendar-table">
          <thead  class="calendar-thead"  >
            <tr  class="calendar-thead-tr"  >
              <th  class="calendar-thead-th"  >一</th>
              <th  class="calendar-thead-th"  >二</th>
              <th  class="calendar-thead-th"  >三</th>
              <th  class="calendar-thead-th"  >四</th>
              <th  class="calendar-thead-th"  >五</th>
              <th  class="calendar-thead-th"  >六</th>
              <th  class="calendar-thead-th"  >日</th>
            </tr>
          </thead>
          <tbody  class="calendar-tbody"  >
            <tr  v-for="trIndex in (calendarList.length/7)" :key="trIndex" >
              <td  class="calendar-td"  :class="{'calendar-td-edit':isEditing}" v-for="tdIndex in 7"  :key="calendarList[(trIndex-1)*7+(tdIndex-1)].factoryDate"     >
                <div  class="calendar-item"  >
                  <a   :class="dayItemObj(trIndex-1,tdIndex-1)"   @click="handleDayClick(trIndex-1,tdIndex-1)"   >
                    <span  class="calendar-daynumber" v-html="dateNum(trIndex-1,tdIndex-1)" ></span>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div  class="calendar-footer"  >
          <a-button icon="check" class="submit-btn"  @click="handelClickEditSubmit"  type="primary" v-show="isEditing"  >提交编辑</a-button>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
import {JeecgListMixin} from '../../mixins/JeecgListMixin.js'
import moment from "moment"
import {getFactoryCalendarListOfGeneral,saveOrUpdateFactoryCalendarListOfGeneral} from '@/api/api.js'
import { Modal } from 'ant-design-vue';

export default {
  data() {
    return {
      disableMixinCreated:true,
      baseValue:"",
      nowYear:2010,
      nowMonth:0,
      nowDate:1,
      calendarList:[],
      momthOption:[1,2,3,4,5,6,7,8,9,10,11,12],
      yearOption:[],
      isLoaddingCalendarData:false,
      isEditing:false,
      hasEidted:false,
      trCount:0,
      isUploaddingData:false,
    }
  },
  created(){
    moment.locale('zh-cn');
    let todayMoment=moment()
    let yearTemp=todayMoment.year()
    let yearArr=[]
    for (let index = yearTemp-10; index < yearTemp+10; index++) {
      yearArr.push(index)
    }
    this.yearOption=yearArr;
  },
  methods: {
    dayItemObj(trIndex,tdIndex){
      let days=this.calendarList[(trIndex)*7+(tdIndex)]
      return {
        'calendar-a':true,
        'not-now-month':!days.isNowMonth,
        'selection-day':this.isSelectionDay(days),
        'sign-rest':days.factoryType&&(days.factoryType=='rest')?true:false,
        'sign-work':days.factoryType&&(days.factoryType=='work')?true:false,
        'sign-has-eidted':days.hasEidted?true:false,
        // 'calendar-a-edit':this.isEditing&&(days.month==this.nowMonth)
      }
    },
    dateNum(trIndex,tdIndex){
      return this.calendarList[(trIndex)*7+(tdIndex)].date
    },
    monthChange(){
      let endDay=moment().year(this.nowYear).month(this.nowMonth-1).endOf('month').date();
      if(endDay<this.nowDate){
        this.nowDate=endDay
      }
      let momth=this.nowMonth>9?String(this.nowMonth):'0'+String(this.nowMonth)
      let date=this.nowDate>9?String(this.nowDate):'0'+String(this.nowDate)
      this.getMonthCalendar(this.nowYear+'-'+momth+'-'+date)
    },
    isSelectionDay(days){
      if((days.year==this.nowYear)&&(days.month==this.nowMonth)&&(days.date==this.nowDate)&&!this.isEditing){
        return true
      }
      return false
    },
    getMonthCalendar(dateStr){
      let nowMoment;
      let momentPointer;
      let calendaEndMoment;
      if(!dateStr){
        nowMoment=moment();
        momentPointer=moment().startOf("month").startOf('week');
        calendaEndMoment=moment().endOf("month").endOf('week');
      }else{
        nowMoment= moment(dateStr,'YYYY-MM-DD');
        momentPointer=moment(dateStr,'YYYY-MM-DD').startOf("month").startOf('week');
        calendaEndMoment=moment(dateStr,'YYYY-MM-DD').endOf("month").endOf('week');
      }
      let weeksNum=calendaEndMoment.diff(momentPointer,'weeks')+1;
      let calendarArrTemp=[];
      for (let i = 0; i < weeksNum; i++) {
        for (let j = 0; j < 7; j++) {
          let isNowMonth=momentPointer.month()==nowMoment.month()
          calendarArrTemp.push({
            factoryDate:momentPointer.format("YYYY-MM-DD"),
            year:momentPointer.year(),
            month:momentPointer.month()+1,
            date:momentPointer.date(),
            isNowMonth
          })
          momentPointer.add(1,'days')
        }
      }
      this.trCount=Math.ceil(this.calendarList.length/7)
      this.calendarList=calendarArrTemp;
      this.getFactoryCalendarData()
    },
    getFactoryCalendarData(){
      this.isLoaddingCalendarData=true
      let startDate=moment().year(this.nowYear).month(this.nowMonth-1).startOf("month").format("YYYY-MM-DD")
      let endDate=moment().year(this.nowYear).month(this.nowMonth-1).endOf("month").format("YYYY-MM-DD")
      let params={
        startDate,
        endDate,
        baseId:this.baseValue,
      }
      getFactoryCalendarListOfGeneral(params).then((res)=>{
        if(res.code==200&&res.success){
          if(res.result.length==0){
            return
          }
          //排版表数据填充进去
          let dataTemp=this.calendarList.map((item,index)=>{
            res.result.some((element)=>{
              if(element.factoryDate==item.factoryDate){
                item.id=element.id;
                this.$set(item,'factoryType',element.factoryType)
                return true
              }
            })
            return item
          })
          this.calendarList=dataTemp
          this.hasEidted=false
        }else{
          this.$message.error(res.message)
        }
      }).finally(()=>{
        this.isLoaddingCalendarData=false
      })
    },
    submitEdit(){
      let editCatchList=[]
      editCatchList=this.calendarList.filter((item)=>{
        return item.hasEidted&&(item.hasEidted==true)
      })
      if(editCatchList.length==0){
        this.$message.success("当前没有修改，无需提交")
        return
      }
      let factoryCalendarList=editCatchList.map((item)=>{
        let obj={
          factoryDate:item.factoryDate,
          factoryType:item.factoryType,
          baseId:this.baseValue,
        }
        if(item.id){
          obj.id=item.id
        }
        return obj
      })
      let params={
        factoryCalendarList
      }
      this.isUploaddingData=true;
      saveOrUpdateFactoryCalendarListOfGeneral(params).then((res)=>{
        if(res.code==200&&res.success){
          this.$message.success(res.message)
          this.getMonthCalendar(this.nowYear+'-'+this.nowMonth+'-'+this.nowDate)
        }else{
          this.$message.error(res.message)
        }
      }).finally(()=>{
        this.isUploaddingData=false
      })
    },
    handelClickEditSubmit(){
      Modal.confirm({
        title: '提示?',
        content: '是否提交修改的工程日历',
        okText: '提交',
        cancelText: '我再改改',
        onOk:()=> {
          this.submitEdit();
        },
        onCancel:()=> {
        },
      });
    },
    handleDayClick(trIndex,tdIndex){
      let days=this.calendarList[(trIndex)*7+(tdIndex)]
      if(this.isEditing){
        if(days.month!=this.nowMonth){
          this.$message.error("只能修改当前选择月份，要修改其他月份请重新选择月份")
          return
        }
        if(days.factoryType){
          if(days.factoryType=="work"){
            this.$set(days,"factoryType","rest")
          }else if(days.factoryType=="rest"){
            this.$set(days,"factoryType","work")
          }
        }else{
          this.$set(days,"factoryType","work")
        }
        this.hasEidted=true;
        this.$set(days,"hasEidted",true)
      }else{
        if(days.month==this.nowMonth){
          this.nowDate=days.date;
        }else{
          this.nowYear=days.year;
          this.nowMonth=days.month;
          this.nowDate=days.date;
          this.getMonthCalendar(this.nowYear+'-'+this.nowMonth+'-'+this.nowDate)
        }
      }
    },
    handleGotoToday(){
      this.nowYear=moment().year();
      this.nowMonth=moment().month()+1;
      this.nowDate=moment().date();
      this.getMonthCalendar();
    },
    handleEdit(){
      this.isEditing=!this.isEditing;
      if(this.isEditing==false){
        this.hasEidted=false
        this.getMonthCalendar(this.nowYear+'-'+this.nowMonth+'-'+this.nowDate)
      }
    },
    handleChangeYear(value){
      if(this.isEditing&&this.hasEidted){
        Modal.confirm({
          title: '提示?',
          content: '有修改，但是未保存的数据，是否提交修改的工程日历',
          okText: '保存',
          cancelText: '不保存',
          onOk:()=> {
            this.submitEdit();
          },
          onCancel:()=> {
            this.nowYear=value
            this.monthChange()
          },
        });
      }else{
        this.nowYear=value
        this.monthChange()
      }
    },
    handleChangeMonth(value){
      if(this.isEditing&&this.hasEidted){
        Modal.confirm({
          title: '提示?',
          content: '有修改，但是未保存的数据，是否提交修改的工程日历',
          okText: '保存',
          cancelText: '不保存',
          onOk:()=> {
            this.submitEdit();
          },
          onCancel:()=> {
            this.nowMonth=value
            this.monthChange()
          },
        });
      }else{
        this.nowMonth=value
        this.monthChange()
      }
      
    },
    handleChangeBase(value){
      if(this.isEditing&&this.hasEidted){
        Modal.confirm({
          title: '提示?',
          content: '有修改，但是未保存的数据，是否提交修改的工程日历',
          okText: '保存',
          cancelText: '不保存',
          onOk:()=> {
            this.submitEdit();
          },
          onCancel:()=> {
            this.baseValue=value;
            this.monthChange()
          },
        });
      }else{
        this.baseValue=value
        this.monthChange()
      }
    },
    handleLastMonth(){
      if(this.nowMonth==1){
        this.nowYear=this.nowYear-1
        this.nowMonth=12
        this.monthChange()
      }else{
        this.nowMonth=this.nowMonth-1
        this.monthChange()
      }
    },
    handleNextMonth(){
      if(this.nowMonth==12){
        this.nowYear=this.nowYear+1
        this.nowMonth=1
        this.monthChange()
      }else{
        this.nowMonth=this.nowMonth+1
        this.monthChange()
      }
    }
  },
  mixins:[JeecgListMixin],
  watch:{
  },
  components:{
  }
}
</script>

<style lang="less">
.operate-div{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 70px;
  .base-div{
    width: 200px;
    .margin-botton-0{
      margin-bottom: 0px;
    }
  }
  .year-div{
    width: 150px;
    margin-left: 20px;
    .margin-botton-0{
      margin-bottom: 0px;
    }
  }
  .month-div{
    width: 110px;
    .margin-botton-0{
      margin-bottom: 0px;
    }
  }
  .left-icon{
    margin-left: 20px;
    margin-right: 10px;
  }
  .right-icon{
    margin-left: 10px;
    margin-right: 20px;
  }
  .margin-left-20{
    margin-left: 20px;
  }
}
.calendar{
  .calendar-box{
    border-collapse: collapse;
    margin: 0 -16px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .1);
    border-radius: 16px;
    border: 2px solid #4E6EF2;
    padding: 15px 15px 0;
    display:inline-block;
    .calendar-header{
      display: flex;
      flex-direction: row;
      width: 100%;
      .now-date{
        font-size: 17px;
      }
      .spin-div{
        margin-left:auto;
          .spin-p{
          color: #4E6EF2;
        }
      }
    }
    .calendar-footer{
      display: flex;
      flex-direction: row;
      width: 100%;
      margin:10px 0px;
      .submit-btn{
        margin-left: auto;
      }
    }
    .calendar-table{
      border: 0;
      border-collapse: collapse;
      border-spacing: 0;
      .calendar-thead{
        display: table-header-group;
        vertical-align: middle;
        border-color: inherit;
        .calendar-thead-tr{
          border-collapse: collapse;
          border-spacing: 0;
          text-align: center;
          .calendar-thead-th{
            width: 90px;
            height: 30px;
            font-size: 15px;
            color: #4E6EF2;
          }
        }
      }
      .calendar-tbody{
        .calendar-td{
          border: 1px solid fade(#BDBFC8,30%);
        }
        .calendar-td-edit{
          border: 1px solid fade(#F73131,20%);
        }
        .calendar-a{
          opacity: 1;
          display: block;
          width: 90px;
          height: 80px;
          text-align: center;
          border: 2px solid transparent;
          border-radius: 6px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          &:hover{
            border: 2px solid #BDBFC8;
          }
          .calendar-daynumber{
            cursor: pointer;
            display: block;
            line-height: 80px;
            font-size: 20px;
            color: #000;
          }
        }
        .calendar-a-edit{
          border: 2px solid #BDBFC8;
        }
        .not-now-month{
          opacity: 0.4;
        }
        .sign-work::before{
          content: "班";
          position:absolute;
          left: 7px;
          top: 7px;
        }
        .sign-rest{
          background-color: fade(#F73131,20%);
        }
        .sign-rest::before{
          position:absolute;
          left: 7px;
          top: 7px;
          content: "休";
          color: #F73131;
        }
        .sign-has-eidted::after{
          position:absolute;
          right: 14px;
          top: 14px;
          width: 4px;
          height: 4px;
          background: green;
          border-radius: 2px;
          content: "";
        }
        .selection-day{
          border: 2px solid #4E6EF2 !important;
        }
      }
    }
  }
  .calendar-box-edit{
    border: 2px solid #F73131;
  }
}
</style>